<template>
  <v-list>
    <v-list-group :value="false" :ripple="false" color="black" class="px-4">
      <template v-slot:activator>
        <v-list-item-title class="title">
          {{ category.name }}
          <v-btn v-if="user.superUser" @click.stop="edit(category)" small tile outlined dark
            class="warning ml-2">edit</v-btn>
          <v-btn @click.stop="deleteCategory(category)" v-if="user.superUser" small tile outlined dark
            class="primary ml-2">delete</v-btn>
        </v-list-item-title>
      </template>
      <v-list-item v-for="(subcategory, i) in category.categories" link :ripple="false" :key="i">
        <v-list-item-content>
          <v-list-item-title>{{ subcategory.name }}<a v-if="subcategory.url" rel="noopener noreferrer"
              :href="`${subcategory.url}`" target="_blank"> - Link</a></v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="user.superUser">
          <v-row no-gutters>
            <v-col>
              <v-btn tile outlined color="primary" @click="deleteSubcategory(subcategory._id)">Delete</v-btn>
              <v-btn tile outlined dark class="warning ml-2" @click="edit(subcategory)">EDIT</v-btn>
            </v-col>
          </v-row>
        </v-list-item-action>
      </v-list-item>
      <v-list-item>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn tile outlined dark class="primary ml-2 mt-2" v-on="on">New Item</v-btn>
          </template>
          <v-card>
            <v-card-text>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field v-model="editedItem.name" hide-details placeholder="Name"
                    :autofocus="true"></v-text-field>
                  <v-text-field v-model="editedItem.url" hide-details placeholder="URL"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outlined tile class="ma-2" color="primary" @click="close">Cancel</v-btn>
              <v-btn tile text class="primary ma-2" @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SubcategoryCreate",
  data() {
    return {
      subcategory: "",
      search: "",
      editedItem: {},
      dialog: false,
      validSubcategory: false,
      validSubcategoryEdit: false,
      nameRules: [(v) => !!v || "Name is required"],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
        },
        { text: "", value: "action", sortable: false, align: "right" },
      ],
    };
  },
  props: ["category"],
  methods: {
    ...mapActions(["updateTopCategory", "setSnackbar"]),
    onClick() {
      this.category.categories.push({
        name: this.editedItem.name,
      });
      this.updateTopCategory(this.category).then(() => {
        this.editedItem = {};
        this.dialog = false;
      });
    },
    close() {
      this.dialog = false;
      this.editedItem = {};
    },
    edit(item) {
      this.dialog = true;
      this.editedItem = { ...item };
    },
    deleteCategory(cat) {
      this.$emit("deleteCategory", cat._id);
    },
    deleteSubcategory(id) {
      this.category.categories = this.category.categories.filter(
        (cat) => cat._id !== id
      );
      return this.updateTopCategory(this.category).then(() => {
        this.setSnackbar({
          text: `Subcategory deleted.`,
          color: "primary",
        });
      });
    },
    save() {
      if (this.editedItem.categories) {
        this.category.name = this.editedItem.name;
      } else {
        let subcat = this.category.categories.find(
          (cat) => cat._id === this.editedItem._id
        );
        if (subcat) {
          subcat.name = this.editedItem.name;
          subcat.url = this.editedItem.url;
        } else {
          this.category.categories.push({
            name: this.editedItem.name,
            url: this.editedItem.url,
          });
        }
      }
      this.updateTopCategory(this.category).then(() => {
        this.editedItem = {};
        this.dialog = false;
        this.setSnackbar({
          text: `Subcategory saved.`,
        });
      });
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<style>

</style>
